import {load} from '@shopify/theme-sections';

import '../sections/most-loved-blog-posts';

import Filter from '../sections/filter';

if (document.body.classList.contains('template-blog')) {
  if (document.body.id === 'news') {
    Filter().init();
    load('*');
  }
}
